/**
 * Hier werden Dienste aufgelistet die in einem der Module
 * im /modules-Verzeichnis sind und für Angular verfügbar sein sollen.
 */
angular
.module("impactx.z")
.service("SearchFilterService", [
    "searchFilter",
    "SearchFilter",
    function (searchFilter, SearchFilter) {
        var self = this;

        // Delegate all methods and properties from SearchFilter service
        angular.forEach(SearchFilter, function (value, key) {
            if (typeof value === 'function') {
                self[key] = function () {
                    return SearchFilter[key].apply(SearchFilter, arguments);
                };
            } else {
                self[key] = value;
            }
        });

        this.setSearchInput = function (value) {
            searchFilter.searchInput = value;
        };

        this.getSearchInput = function () {
            return searchFilter.searchInput;
        };

        this.resetSearch = function () {
            SearchFilter.resetSearch();
        };

        this.resetSearch = function () {
            SearchFilter.resetSearch();
        };

        this.getFilters = function () {
            return SearchFilter.getFilters();
        };

        this.resetSort = function () {
            return SearchFilter.resetSort();
        };

        this.sortByName = function (asc) {
            return SearchFilter.sortByName(asc);
        };

        this.getSelectedSort = function (sortId) {
            return SearchFilter.getSelectedSort(sortId);
        };
    },
])
.service("AngularModulesMigrationService", [
    "AppConfiguration",
    "basketTemplateMenu",
    "CancellationService",
    "SearchService",
    "SearchFilterService",
    // Reihenfolge MUSS der Parameterliste der Funktion unten entsprechen. Vorher stand
    // "SearchFilter" an vorletzter Stelle, wodurch ab hier alles um eins verschoben war:
    // der Parameter SearchFilter bekam den SearchFilterStorage, TemplateNameService bekam den
    // LoginService usw. Folge: ixTryRegisterService() registrierte fuenf Services unter falschem
    // Namen fuer die Angular-Bridges ("No method"-Fehler in migration.base.service.ts).
    "SearchFilter",
    "SearchFilterStorage",
    "TemplateNameService",
    "LoginService",
    "BasketService",
    "BANFService",
    "FreeFromService",
    function (AppConfiguration, basketTemplateMenu, CancellationService, SearchService, SearchFilterService, SearchFilter, SearchFilterStorage, TemplateNameService, LoginService,
              BasketService, BANFService, FreeFromService) {
        ixTryRegisterService("AppConfiguration", AppConfiguration);
        ixTryRegisterService("basketTemplateMenu", basketTemplateMenu);
        ixTryRegisterService("CancellationService", CancellationService);
        ixTryRegisterService("LoginService", LoginService);
        ixTryRegisterService("SearchService", SearchService);
        ixTryRegisterService("SearchFilterService", SearchFilterService);
        ixTryRegisterService("SearchFilter", SearchFilter);
        ixTryRegisterService("SearchFilterStorage", SearchFilterStorage);
        ixTryRegisterService("TemplateNameService", TemplateNameService);
        ixTryRegisterService("BasketService", BasketService);
        ixTryRegisterService("BANFService", BANFService);
        ixTryRegisterService("FreeFromService", FreeFromService);

        this.hasLoadedServices = function () {
            return true;
        };
    },
]);
